// extracted by mini-css-extract-plugin
module.exports = {"outer-border":"HexagonBorder-module__outer-border__1hU23","inner-border":"HexagonBorder-module__inner-border__2EIKE"};